import React, { useState, Fragment } from 'react';

import Accordion from '../../common/Accordion/Accordion.jsx';

function CategoryMenu({
    sectionDetails,
    sectionClick,
    sidebar,
    productTileClick
}) {

    // This is used for both mobile dropdown and desktop sidebar
    // Desktop: one section (accordian comp) always has to be open (index: 0)
    // Mobile:  default should closed (index null)
    // Both:  as you open one section, the previous opened section should close
    const [openIndex, setOpenIndex] = useState(sidebar ? 0 : null);

    function handleProductClick(e, pid) {
        if (productTileClick) {
            productTileClick(e, pid);
        }
    }

    function handleSectionTitleClick(newIndex) {
        if (newIndex != openIndex) {
            setOpenIndex(newIndex);

            if (sectionClick) {
                sectionClick(newIndex);
            }
        } else {
            if (! sidebar){ // mobile menu
                setOpenIndex(null); // to close on mobile
            }
        }
    }

    const accordianOpenIcon  = getStaticFile("/images/svg/orange-minus.svg");
    const accordianCloseIcon = sidebar ? getStaticFile("/images/mc/icon_arrow_down_black.png") : getStaticFile("/images/svg/White-down-arrow_Icon.svg");

    sectionDetails.forEach(section => {
       section.frameData = section.frameData.sort((a,b) => (a.pDisplayName > b.pDisplayName) ? 1 : ((b.pDisplayName > a.pDisplayName) ? -1 : 0));
    });
   
    return (
        <Fragment>
            {
                sectionDetails.map((info, sectionIndex) => {
                    const title = info['typographyItems'][0]['textContent'];
                    return (
                        <div>
                            <Accordion 
                                title={title} 
                                className="benefits-frame-accordian-container"
                                onClick={() => handleSectionTitleClick(sectionIndex)}
                                open = {sectionIndex == openIndex ? true : false}
                                openIcon = {accordianOpenIcon}
                                closeIcon = {accordianCloseIcon}
                                key = {sectionIndex}
                            >
                            {
                                info['frameData'].map((frameData, frameDataIndex) => {
                                    let trackingAttrs = { //product specific attributes for tracking
                                        pid:frameData['productId'], offername:frameData['pDisplayName'], offercategory:frameData['primary_catName'], 
                                        offertype:frameData['productTypeId'].concat(' - ', frameData['productTypeName']), contentcity:frameData['geographicName']
                                    };
                                    return (
                                        <p className="product-title" 
                                           key={frameDataIndex}
                                           dangerouslySetInnerHTML={{__html: frameData['pDisplayName']}}
                                           onClick={e => {handleProductClick(e, frameData['productId'])}}
                                            // attributes for Adobe tracking 
                                            di-type="basic" di-class="Body Click" di-id="Product Tile"
                                            {...trackingAttrs}
                                        />
                                    );
                                })
                            }
                            </Accordion>
                            <hr />
                        </div>
                    );
                })
            }
        </Fragment>  
    )
}

export default CategoryMenu;
